module.exports = __webpack_public_path__ + "img/proceso.5ba4527e.webp";